export type InboxKeyAction = 'next' | 'previous' | 'done' | 'unread' | 'search';

export interface InboxKeyPress {
  key: string;
  metaKey: boolean;
  ctrlKey: boolean;
  altKey: boolean;
  typing: boolean;
}

const KEY_ACTIONS: Record<string, InboxKeyAction> = {
  j: 'next',
  k: 'previous',
  e: 'done',
  u: 'unread',
  '/': 'search',
};

export function inboxKeyAction(press: InboxKeyPress): InboxKeyAction | null {
  if (press.typing || press.metaKey || press.ctrlKey || press.altKey) {
    return null;
  }
  return KEY_ACTIONS[press.key.toLowerCase()] ?? null;
}

export function isTypingTarget(target: EventTarget | null): boolean {
  if (typeof HTMLElement === 'undefined' || !(target instanceof HTMLElement)) {
    return false;
  }
  return (
    target.isContentEditable ||
    ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName) ||
    target.getAttribute('role') === 'combobox'
  );
}

export function neighbourId(
  ids: string[],
  currentId: string | undefined,
  step: 1 | -1,
): string | null {
  if (ids.length === 0) {
    return null;
  }
  const index = currentId ? ids.indexOf(currentId) : -1;
  if (index === -1) {
    return ids[0] ?? null;
  }
  const next = Math.min(Math.max(index + step, 0), ids.length - 1);
  return next === index ? null : (ids[next] ?? null);
}

export type ComposerIntent = 'send' | 'newline';

export function composerKeyIntent(press: {
  key: string;
  shiftKey: boolean;
  isComposing: boolean;
}): ComposerIntent | null {
  if (press.key !== 'Enter' || press.isComposing) {
    return null;
  }
  return press.shiftKey ? 'newline' : 'send';
}
